module.exports = __webpack_public_path__ + "img/phone.f1456fc2.svg";